import { selectOrganizationSelected } from "@app/organizations";
import { useSelector } from "@app/react";
import { useActivityFilters } from "@app/ui/hooks";
import { ActivityTableFreezer } from "@app/ui/shared/activity";
import { Link } from "react-router-dom";
import { LoadingSpinner } from "../index";
import {
  HOME_DASH_EVENTS,
  homeDashEvent,
  homeDashOrgPayload,
} from "./tuna-events";

export const ActivityFeedCompact = () => {
  const org = useSelector(selectOrganizationSelected);
  const result = useActivityFilters({
    orgId: org.id,
    hideFilters: true,
    limit: 5,
  });

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <h2 className="text-lg font-medium">Activity Feed</h2>
          {result.isLoading && <LoadingSpinner />}
        </div>
        <Link
          to="/activity"
          className="text-sm font-medium text-blue-600 hover:text-blue-800"
          onClick={() =>
            homeDashEvent(HOME_DASH_EVENTS.ACTIVITY_FEED_VIEW_ALL_CLICK, {
              ...homeDashOrgPayload(org),
            })
          }
        >
          View All →
        </Link>
      </div>

      <ActivityTableFreezer
        {...result}
        showTitle={false}
        hidePagination={true}
        initialColumnVisibility={{ additionalInfo: false }}
      />
    </div>
  );
};
